// 过滤不影响当前接口是否成功的错误值
const codeFilter = {
  // 103266 权限变更，消息通知成员为空
  // 103236 用户权限变更，发送消息失败
  // 103237 用户权限变更，发送消息执行失败
  message: [103266, 103236, 103237],
};

export const matchMessageCodeFilter = (code: number) => {
  return codeFilter.message.includes(code);
};
